import { Record } from 'immutable';

const AccountRecord = Record({
    address: '',
    address2: '',
    city: '',
    country: '',
    dateOfBirth: '',
    email1: '',
    firstname: '',
    homePhone: '',
    lastname: '',
    postalCode: '',
    province: '',
    sexId: 0,
    username: '',
    workPhone: '',
    workPhoneExtension: '',
    email: '',
    phoneNumber: '',
});

class Account extends AccountRecord {
    constructor(args) {
        const newArgs = {};

        if (args) {
            if (args.email1) {
                newArgs.email = args.email1;
            }

            if (args.homePhone) {
                newArgs.phoneNumber = args.homePhone;
            }
        }

        super({ ...args, ...newArgs });
    }
}

export default Account;



// WEBPACK FOOTER //
// ./src/models/Account/AccountModel.js